import { GetterTree } from 'vuex';
import { SiteState } from './types/site.types';
import { RootState } from '@/store/store';

export const siteGetters: GetterTree<SiteState, RootState> = {

};
